import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PosterOne from "../share/component.jsx/posterone";
import aboutbanner from "../assets/aboutbanner.jpg";
import BannerOne from "../share/component.jsx/banner";

const SERVICES = [
  { id: 1, image: require("../assets/services/Medical Document Translation.jpg"), name: "Medical Document Translation", desc: "Our medical documentation translation services include clinical trial protocols, informed consent documents, patient information sheets, referral letters, and regulatory documents. Each document is translated with considerable accuracy, ensuring that medical terminology, patient information, and meaning are accurate." },
  { id: 2, image: require("../assets/services/Clinical Report Translation.jpg"), name: "Clinical Report Translation", desc: "Discharge summaries, operative notes, diagnostic reports, laboratory reports, imaging reports, and patient histories are translated. Our healthcare translation services are able to convey crucial records between patients and medical professionals before treatment, second opinions, referrals, or overseas consultations." },
  { id: 3, image: require("../assets/services/Research Paper Translation.jpg"), name: "Research Paper Translation", desc: "We provide research paper translation for doctors, researchers, and academic teams for journals, conferences, and the rest of the world. We can translate peer-reviewed articles, abstracts, manuscripts, and scientific texts into clear language, accessible to most international readers." },
  { id: 4, image: require("../assets/services/Regulatory Translation.jpg"), name: "Regulatory Translation", desc: "We provide document translation services for regulatory submissions, instructions for use, label translation, package inserts, IFUs, and healthcare compliance documents, all of which are certified documents. We abide by the correct terminology and formatting." },
  { id: 5, image: require("../assets/services/Medical Education Materials.jpg"), name: "Medical Education Materials", desc: "Patient education guides, medical training material, healthcare brochures, continuing education material, and awareness material are translated by us. Hospitals, clinics, and educators can use our medical translation services to disseminate medical information in various languages." },
  { id: 6, image: require("../assets/services/Interpretation Services.jpg"), name: "Interpretation Services", desc: "Support is available during doctor's consultations, medical conferences, second opinions, and telemedicine consultations. Our healthcare language translation services enable patients and medical professionals to communicate effectively in crucial healthcare conversations." },
];

const LANGUAGES = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "zh", name: "Chinese (Mandarin)", flag: "🇨🇳" },
  { code: "ar", name: "Arabic", flag: "🇸🇦" },
  { code: "fr", name: "French", flag: "🇫🇷" },
  { code: "de", name: "German", flag: "🇩🇪" },
  { code: "es", name: "Spanish", flag: "🇪🇸" },
  { code: "ja", name: "Japanese", flag: "🇯🇵" },
  { code: "ko", name: "Korean", flag: "🇰🇷" },
  { code: "ru", name: "Russian", flag: "🇷🇺" },
  { code: "pt", name: "Portuguese", flag: "🇧🇷" },
];

const PROCESS = [
  { num: "01", title: "Document Assessment", desc: "Your documents are reviewed first so that we can understand what they are, the language pair, medical specialty, file type, and delivery requirements. This will enable us to select the right person to translate for us and ensure high levels of medical accuracy." },
  { num: "02", title: "Expert Matching", desc: "Your project is given to native speaking translators who have medical experience. For content in cardiology and cardiovascular care, we have selected individuals who are familiar with medical and treatment terminology as well as patient-care communication." },
  { num: "03", title: "Translation & Review", desc: "The first version is carefully composed by our translator, taking care of meaning, tone, and terminology. Following this, a second qualified reviewer reviews the content for accuracy, medical clarity, grammar, and consistency." },
  { num: "04", title: "Medical Validation", desc: "Final content is reviewed by a medical professional if clinical validation is required. This helps ensure that vital medical terms, diagnosis information, treatment notes, and instructions are accurate and easily understood." },
  { num: "05", title: "Delivery & Certification", desc: "Final translation is provided in your format of choice. We also provide certified translation and optional notarisation services for official/legal, academic, and healthcare purposes as required." },
];

export default function MedicalLanguageTranslation() {
  const navigate = useNavigate();
  const [activeProcess, setActiveProcess] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActiveProcess(p => (p + 1) % PROCESS.length), 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
     <BannerOne
  img={require('../assets/symptoms/languageBanner.png')}
  title={
    <>
      Medical Language <br /> 
      Translation Services 
    </>
  }
/>
      <div className="service-root acc-root">
        {/* <PosterOne img={aboutbanner} title={"Medical Language Translation Services"} /> */}
        

        <section className="service-section">
          <div className="service-container">
            <p className="service-eyebrow">Our Services</p>
            <h2 className="service-heading">Professional <em>Medical Translation</em> Solutions</h2>
            <p className="service-subtitle">We offer medical language translation services to patients, doctors, researchers, hospitals, and health care institutions. We specialize in professional translation from a cardiology, cardiovascular surgical, and medical perspective, making it easy, accurate, and clinically correct. With Professional medical language translation services, the client can be more confident to share medical information across countries, with more understanding and no communication gap.</p>
            <div className="service-grid">
              {SERVICES.map(s => (
                <div key={s.id} className="service-card">
                  <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s", marginBottom: 16 }}>
          {s.image ? (
            <img src={s.image} alt={s.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{s.icon}</span>
          )}
        </div>
                  <h3>{s.name}</h3>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-section service-section-alt">
          <div className="service-container">
            <p className="service-eyebrow">Languages We Cover</p>
            <h2 className="service-heading">Translation in <em>10+ Languages</em></h2>
            <p className="service-subtitle">You can get translation services in over 10 languages with native speaking medical translators. We have knowledge in cardiovascular medicine, medical terms, patient communication, and comprehension of international healthcare needs. Additionally, clients can also ask for medical translation online to avail prompt assistance, secure sharing of documents, and remote project handling. This simplifies the process for foreign patients, physicians, scientists, and health care professionals.</p>
            <div className="service-languages">
              {LANGUAGES.map(l => (
                <div key={l.code} className="service-lang">
                  <span>{l.flag}</span>
                  <span>{l.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-section">
          <div className="service-container">
            <p className="service-eyebrow">Our Process</p>
            <h2 className="service-heading">Quality-Focused <em>Workflow</em></h2>
            <div className="service-process">
              {PROCESS.map(p => (
                <div key={p.num} className="service-process-step">
                  <div className="service-process-num">{p.num}</div>
                  <div className="service-process-title">{p.title}</div>
                  <div className="service-process-desc">{p.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="service-cta">
          <div className="service-container">
            <h2>Your Medical Documents, Translated With Full Accuracy</h2>
            <p>Send us your documents today. We will review your language pair, document type, and clinical requirements, then assign the right medical translator to deliver a clear and certified result.</p>
            <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
          </div>
        </section>
      </div>
    </>
  );
}